import { useContext } from "react";

import ServiceStackClientContext from "src/contexts/api/ServiceStackClientContext";

/**
 * Returns the client supplied by the current ServiceStack context.
 *
 * Postconditions: Uses the context default when no provider is present; this hook does not create
 * a request or validate credentials.
 */
const useServiceStackClient = () => {
    return useContext(ServiceStackClientContext);
};

export default useServiceStackClient;
